import { TasksSearchRequestDto } from '@/api/generated';
import {
  resourceTypeTranslation,
  ResourceTypeTranslation,
  taskStatusOptionsTranslation,
  TaskStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl';

export type TasksListTableBodyTranslation = {
  actions: string;
  assignedUser: string;
  contextResourceType: string;
  creator: string;
  dueDate: string;
  resourceTypeOptions: ResourceTypeTranslation;
  status: string;
  taskStatusOptions: TaskStatusOptionsTranslation;
  title: string;
};

export const tasksListTablBodyTranslation: TasksListTableBodyTranslation = {
  actions: '',
  assignedUser: 'Przypisany pracownik',
  contextResourceType: 'Typ zasobu',
  creator: 'Twórca',
  dueDate: 'Termin',
  resourceTypeOptions: resourceTypeTranslation,
  status: 'Status',
  taskStatusOptions: taskStatusOptionsTranslation,
  title: 'Tytuł',
};

export type TasksListViewTranslation = {
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: TasksListTableBodyTranslation;
    details: {
      assignedUser: string;
      contextResource: string;
      creator: string;
      description: string;
      noDescription: string;
      open: string;
      people: string;
      updatedAt: string;
      watchers: string;
    };
    head: Record<keyof Omit<TasksSearchRequestDto, 'contextResourceId'>, string> & {
      resourceTypeOptions: ResourceTypeTranslation;
      taskStatusOptions: TaskStatusOptionsTranslation;
    };
    quickFilters: {
      createdByMe: string;
      createdToday: string;
      dueThisWeek: string;
      dueToday: string;
      mine: string;
      overdue: string;
      watched: string;
    };
  };
};

export const tasksListViewTranslation: TasksListViewTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: tasksListTablBodyTranslation,
    details: {
      assignedUser: 'Wykonawca',
      contextResource: 'Dotyczy',
      creator: 'Zlecił',
      description: 'Opis',
      noDescription: 'Brak opisu',
      open: 'Otwórz zadanie',
      people: 'Osoby',
      updatedAt: 'Ostatnia zmiana',
      watchers: 'Obserwujący',
    },
    head: {
      assignedUserId: 'Przypisane do',
      contextResourceTypes: 'Typy zasobu',
      creationDateFrom: 'Utworzone od',
      creationDateTo: 'Utworzone do',
      creatorUserId: 'Utworzone przez',
      dueDateFrom: 'Termin od',
      dueDateTo: 'Termin do',
      fullTextSearchInput: 'Tytuł lub opis',
      resourceTypeOptions: resourceTypeTranslation,
      taskStatuses: 'Status',
      taskStatusOptions: taskStatusOptionsTranslation,
      watchersUserIds: 'Obserwujący',
    },
    quickFilters: {
      createdByMe: 'Zlecone przeze mnie',
      createdToday: 'Dodane dziś',
      dueThisWeek: 'Na ten tydzień',
      dueToday: 'Na dziś',
      mine: 'Tylko moje',
      overdue: 'Po terminie',
      watched: 'Obserwowane',
    },
  },
};
